export default {
    timeFormate(timeStamp) {
        let year = new Date(timeStamp).getFullYear();
        let month = new Date(timeStamp).getMonth() + 1 < 10 ? "0" + (new Date(timeStamp).getMonth() + 1) : new Date(timeStamp).getMonth() + 1;
        let date = new Date(timeStamp).getDate() < 10 ? "0" + new Date(timeStamp).getDate() : new Date(timeStamp).getDate();
        let hh = new Date(timeStamp).getHours() < 10 ? "0" + new Date(timeStamp).getHours() : new Date(timeStamp).getHours();
        let mm = new Date(timeStamp).getMinutes() < 10 ? "0" + new Date(timeStamp).getMinutes() : new Date(timeStamp).getMinutes();
        let ss = new Date(timeStamp).getSeconds() < 10 ? "0" + new Date(timeStamp).getSeconds() : new Date(timeStamp).getSeconds();
        return year + "-" + month + "-" + date + " " + hh + ":" + mm + ":" + ss;
        // return nowTime = year + "-" + month + "-" + date + "-" + " " + hh + ":" + mm+":"+ss;

    },
    GettimeStamp(timeStamp) {
        let year = new Date(timeStamp).getFullYear();
        let month = new Date(timeStamp).getMonth() + 1 < 10 ? "0" + (new Date(timeStamp).getMonth() + 1) : new Date(timeStamp).getMonth() + 1;
        let date = new Date(timeStamp).getDate() < 10 ? "0" + new Date(timeStamp).getDate() : new Date(timeStamp).getDate();
        let hh = new Date(timeStamp).getHours() < 10 ? "0" + new Date(timeStamp).getHours() : new Date(timeStamp).getHours();
        let mm = new Date(timeStamp).getMinutes() < 10 ? "0" + new Date(timeStamp).getMinutes() : new Date(timeStamp).getMinutes();
        let ss = new Date(timeStamp).getSeconds() < 10 ? "0" + new Date(timeStamp).getSeconds() : new Date(timeStamp).getSeconds();
        let ml = new Date(timeStamp).getMilliseconds() < 10 ? "0" + new Date(timeStamp).getMilliseconds() : new Date(timeStamp).getMilliseconds();
        return "" + year + month + date + hh + mm + ss + ml;
        // return nowTime = year + "-" + month + "-" + date + "-" + " " + hh + ":" + mm+":"+ss;

    },
    DateDiff(Date_end, Date_start){
        let  aDate,  oDate1,  oDate2,  iDays;
        Date_end = Date_end.split(" "); //将时间以空格划分为两个数组  第一个数组是 2019-05-20 第二个数组是 00：00：00
        aDate   =  Date_end[0].split("-"); //获取第一个数组的值
        oDate1 = new Date(aDate[0] , aDate[1] ,aDate[2]);  //将前半个数组以-拆分，每一个是一个数值
        Date_start = Date_start.split(" ");
        aDate   =  Date_start[0].split("-");
        oDate2 = new Date(aDate[0] , aDate[1] , aDate[2]);
        iDays   =  parseInt(Math.abs(oDate1  -  oDate2)  /  1000  /  60  /  60  /24);    //把相差的毫秒数转换为天数
        return  iDays;
      },
    getNextDate(date, day) { 
        var dt22 = date.replace(/\-/g, '/')
        　　var dd = new Date(dt22);
        　　dd.setDate(dd.getDate() + day);
        　　var y = dd.getFullYear();
        　　var m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
        　　var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
        　　return new Date(y + "/" + m + "/" + d +" 23:00:00");
        },
    // 定时器函数
    getNowStr() {
        return this.timeFormate(new Date());
    },
    getCurrentYearStr(timeStamp) {
        return new Date(timeStamp).getFullYear();
    },
    getCurrentMonthStr(timeStamp) {
        return new Date(timeStamp).getMonth() + 1 < 10 ? "0" + (new Date(timeStamp).getMonth() + 1) : new Date(timeStamp).getMonth() + 1;
    },
    getCurrentDayStr(timeStamp) {
        return new Date(timeStamp).getDate() < 10 ? "0" + new Date(timeStamp).getDate() : new Date(timeStamp).getDate();
    },
    // 判断是否为手机号
    isPhoneAvailable: function(pone) {
        var myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
        if (!myreg.test(pone)) {
            return false;
        } else {
            return true;
        }
    },
    /**
     * 判断是否为电话号码
     * @param {String } tel 电话号码
     */
    isTelAvailable: function(tel) {
        var myreg = /^(([0\+]\d{2,3}-)?(0\d{2,3})-)(\d{7,8})(-(\d{3,}))?$/;
        if (!myreg.test(tel)) {
            return false;
        } else {
            return true;
        }
    },
    /**
     * 验证是否为联系方式
     * @param {String} tel 联系方式
     */
    isContactWay: function(tel) {
        if (this.isTelAvailable(tel) || this.isPhoneAvailable(tel)) {
            return true;
        } else {
            return false;

        }
    },
    /**
     * 判断是否为字母和数字组成
     * @param {String} str 字符串 
     */
    isNumberAndletter: function(str) {

        var reg1 = new RegExp(/^[0-9A-Za-z]+$/);
        if (!reg1.test(str)) {
            return false;
        }
        // var reg = new RegExp(/[A-Za-z].*[0-9]|[0-9].*[A-Za-z]/);
        // if (reg.test(str)) {
        //     return true;
        // } else {
        //     return false;
        // }
        return true;
    },
    number_chinese(str) {
        var num = parseFloat(str);
        var strOutput = "",
            strUnit = '仟佰拾亿仟佰拾万仟佰拾元角分';
        num += "00";
        var intPos = num.indexOf('.');
        if (intPos >= 0) {
            num = num.substring(0, intPos) + num.substr(intPos + 1, 2);
        }
        strUnit = strUnit.substr(strUnit.length - num.length);
        for (var i = 0; i < num.length; i++) {
            strOutput += '零壹贰叁肆伍陆柒捌玖'.substr(num.substr(i, 1), 1) + strUnit.substr(i, 1);
        }
        return strOutput.replace(/零角零分$/, '整').replace(/零[仟佰拾]/g, '零').replace(/零{2,}/g, '零').replace(/零([亿|万])/g, '$1').replace(/零+元/, '元').replace(/亿零{0,3}万/, '亿').replace(/^元/, "零元")

    },
    getUrl() {
         return "https://img.gbbh.cn/"
    },
    getName(){
        //return "工保保函科技"
         return "工保保函（北京）科技有限公司"
    },
    getICP(){
       return "19055464号-5"
         //return "19055464号-1"
    },
    getlvUrl(){
        return "http://guizhoutoubao.jinhanwang.cn/"   //生产环境
    },
    //投保地址
  getTZUrl() {
    return "https://jg1.zbins.com/#/"             //生产环境
  },
  // 判断当前时间是否在早8点和晚19点30分之间
  verifyDate(){
    const time = new Date()
    const h = time.getHours()
    const m = time.getMinutes()
    if(h>=8 && h<=19){  //早8点和晚19点之间  在范围之内
        if(h == 19 && m > 30){
            return false
        }else{
            return true
        }
    }else{  // 不在范围之内
        return false
    }
  }

};


// WEBPACK FOOTER //
// ./src/utils/utils.js